module.exports = __webpack_public_path__ + "img/1-4-p4.f58e1817.svg";